import client from "../httpClient";

const invalidateSessionService = {
  InvalidateSession: () => {
    return client.Get("invalidateSession", [], [], { enabled: false });
  },
};

export default invalidateSessionService;
